import React, { type ReactNode } from 'react';

import { StyledFiltersBar, StyledGroup, StyledLayout, StyledSearchWrapper } from './FiltersBar.style.ts';

export interface FiltersBarProps {
    children: ReactNode;
}

export function FiltersBar({ children }: FiltersBarProps) {
    return <StyledFiltersBar>{children}</StyledFiltersBar>;
}

function Layout({ children }: FiltersBarProps) {
    return <StyledLayout>{children}</StyledLayout>;
}

function Group({ children }: FiltersBarProps) {
    return <StyledGroup>{children}</StyledGroup>;
}

// This should probably be `<Group stretch />`.
function SearchWrapper({ children }: FiltersBarProps) {
    return <StyledSearchWrapper>{children}</StyledSearchWrapper>;
}

FiltersBar.Layout = Layout;
FiltersBar.Group = Group;
FiltersBar.SearchWrapper = SearchWrapper;
